import React, { Component } from 'react';
import Headroom from 'react-headroom';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Grid, Row, css, styled, withTheme, up } from '@smooth-ui/core-sc';
import HeaderLogo from 'theme/logo-goodwe.svg';

const CustomHeadroom = styled(Headroom)`
  .headroom {
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
  }
  .headroom--unfixed {
    position: relative;
    transform: translateY(0);
  }
  .headroom--scrolled {
    transition: transform 200ms ease-in-out;
  }
  .headroom--unpinned {
    position: fixed;
    transform: translateY(-100%);
  }
  .headroom--pinned {
    position: fixed;
    transform: translateY(0%);
  }
`;

const HeaderWrapper = styled.div`
  background-color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100%;
  ${up(
    'xl',
    css`
      height: 110px;
      padding-top: 30px;
    `
  )};

  .sui-row {
    justify-content: space-between;
  }
`;

const LogoContainer = styled.div`
  align-items: center;
  display: flex;
  width: 150px;
  height: 40px;
  justify-content: center;
  margin: 0 10px;
  img {
    height: auto;
    display: block;
  }
  ${up(
    'xl',
    css`
      height: 57px;
      width: 212px;
    `
  )}
`;

const HeaderRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  ${up(
    'lg',
    css`
      flex-direction: column;
      margin-top: 30px;
    `
  )}
`;

class Header extends Component {
  render() {
    return (
      <header className="site-header">
        {/* Leave the above <header /> here, necessary to contain Headroom */}
        {/* Otherwise Headroom will wrap all sibling elements */}
        <CustomHeadroom disableInlineStyles downTolerance={10}>
          <HeaderWrapper className="header-wrapper">
            <Grid>
              <Row>
                <LogoContainer>
                  <Link to="/">
                    <img src={HeaderLogo} alt="GoodWe Rewards" />
                  </Link>
                </LogoContainer>
                <HeaderRightContainer>
                  {this.props.children}
                </HeaderRightContainer>
              </Row>
            </Grid>
          </HeaderWrapper>
        </CustomHeadroom>
      </header>
    );
  }
}

Header.propTypes = {
  children: PropTypes.node,
};

Header.defaultProps = {
  children: undefined,
};

export default withTheme(Header);
